module.exports = __webpack_public_path__ + "img/kri.b40874c7.svg";